import { ExternalLink } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import type { CrmUserActivity } from "@/services/adminCrm";

interface Props {
  activity: CrmUserActivity;
  onLaunch: (path: string) => void;
}

export function UserStatsBar({ activity, onLaunch }: Props) {
  const stats = [
    { label: "Messages", value: activity.messageCount, path: "/chat" },
    { label: "Threads", value: activity.threadCount, path: "/chat" },
    { label: "Outreach Sent", value: activity.outreachSent, path: "/outreach" },
    { label: "School Lists", value: activity.schoolListsCreated, path: "/pipeline" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map(s => (
        <Card
          key={s.label}
          className="cursor-pointer hover:border-primary/50 transition-colors group"
          onClick={() => onLaunch(s.path)}
        >
          <CardContent className="pt-6 pb-4 text-center">
            <div className="text-3xl font-bold tabular-nums">{s.value}</div>
            <div className="text-sm text-muted-foreground mt-1 flex items-center justify-center gap-1">
              {s.label}
              <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
